module.exports = __webpack_public_path__ + "static/media/checkbox-checked.3dabe27d.svg";